module.exports = "/365FarmNet/dist/admin.5ad20e56623fb1b9bc6bdd388b7bd248.html";